export const REQUEST_UNCAUGHT_ERROR = '@@REQUEST_UNCAUGHT_ERROR';
export const REQUEST_QUEUED = '@@REQUEST_QUEUED';
export const RESPONSE_UNHANDLED_STATUS_CODE = '@@RESPONSE_UNHANDLED_STATUS_CODE';
export const RESPONSE_DATA = '@@RESPONSE_DATA';
export const RESPONSE_CREATED = '@@RESPONSE_CREATED';
export const RESPONSE_DELETED = '@@RESPONSE_DELETED';
export const RESPONSE_NOT_JSON = '@@RESPONSE_NOT_JSON';
export const RESPONSE_NOT_FOUND = '@@RESPONSE_NOT_FOUND';
export const RESPONSE_BAD_REQUEST = '@@RESPONSE_BAD_REQUEST';
export const RESPONSE_NO_CONTENT = '@@RESPONSE_NO_CONTENT';
export const RESPONSE_NOT_ALLOWED = '@@RESPONSE_NOT_ALLOWED';
export const RESPONSE_FAILURE = '@@RESPONSE_FAILURE';



// WEBPACK FOOTER //
// ./app/javascript/requests/actionTypes.js